
export const SpaceNavigationAction = {
    FIRST: 'FIRST', 
    LAST: 'LAST',
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS'
}
